<script setup>
import {
  productAdditionalDetailsProps,
  useProductAdditionalDetails
} from "@/components/organisms/product-sheet/additional-details/product-additional-details.mixin";

const props = defineProps({
  ...productAdditionalDetailsProps()
});

const {
  informationsValuesByGroup,
  groupValues,
  featuresToDisplay,
  getIconName
} = useProductAdditionalDetails(props);
</script>

<template>
  <dl>
    <template
      v-for="(groupInfos, index) in informationsValuesByGroup"
      :key="index+groupInfos.groupLabel"
    >
      <dt
        v-if="groupInfos.groupLabel"
        class="u-font-700"
      >
        {{ groupInfos.groupLabel }}
      </dt>
      <dd
        v-for="(info,i) in groupInfos.values"
        :key="i+info.value+index+groupInfos.groupLabel"
        class="u-mb-md"
      >
        {{ info.value }}
      </dd>
    </template>
  </dl>
</template>

<style lang="scss" scoped>
</style>
